import { createRecipe } from './runtime';

const spinnerConfig = {"name":"spinner"}

export const spinner = /* @__PURE__ */ createRecipe(spinnerConfig)